<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 20 20" :class="[`${prefix}-icon`, `${prefix}-icon-manuscriptLib`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_280a280d09__a"><rect width="20" height="20" rx="0"/></clipPath></defs><g clip-path="url(#svg_280a280d09__a)"><path d="M8.125,7.8125C8.2976,7.8125,8.4375,7.9524,8.4375,8.125L8.4375,11.92289C8.4375,12.09547,8.5774,12.23539,8.75,12.23539L11.25,12.23539C11.4226,12.23539,11.5625,12.09547,11.5625,11.92289L11.5625,8.125C11.5625,7.9524,11.7024,7.8125,11.875,7.8125L18.4375,7.8125C18.6101,7.8125,18.75,7.9524,18.75,8.125L18.75,15.9375C18.75,16.8004,18.0504,17.5,17.1875,17.5L2.8125,17.5C1.949551,17.5,1.25,16.8004,1.25,15.9375L1.25,8.125C1.25,7.9524,1.389902,7.8125,1.5625,7.8125L8.125,7.8125ZM16.0828,2.5C16.1872,2.499999809265,16.2848,2.5522205,16.3428,2.63916L18.4261,5.76416C18.5218,5.90775,18.483,6.10178,18.3394,6.19752C18.2881,6.23174,18.2278,6.25,18.1661,6.25L1.833906,6.25C1.6613280000000001,6.25,1.521406,6.1101,1.521406,5.9375C1.521406,5.8758099999999995,1.539666,5.8154900000000005,1.573887,5.76416L3.65723,2.63916C3.71518,2.5522209,3.81276,2.5,3.91725,2.5L16.0828,2.5Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconManuscriptLib',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
